<template>
  <div>
    <CRow>
      <CCol sm="12">&nbsp;</CCol>
      <CCol sm="12">
        <GlobalTable
          :title="'Price List'"
          :fields="fields"
          :items="data"
          :editButton="acceptanceStatus.includes(productStatus) ? true : false"
          :redirectDetail="false"
          :enableAddButton="acceptanceStatus.includes(productStatus) ? true : false"
          :isLoading="isLoading"
          :withCard="false"
          @addForm="addForm"
          @editForm="editForm"
        ></GlobalTable>
      </CCol>
    </CRow>
    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{ title }}</h6>
      </template>

      <Loading v-if="isLoading"></Loading>
      <div v-else>
        <CRow>
          <CCol sm="3">
            <div class="price-for">
              <label for="price_for">Price for</label>
              <model-select
                class="form-control"
                id="price_for"
                :options="productPriceList"
                v-model="$v.priceForm.user_group.$model"
                :isError="$v.priceForm.user_group.$invalid"
                placeholder="-- Harap pilih salah satu --"
              ></model-select>
              <div
                v-if="$v.priceForm.user_group.$invalid"
                class="invalid-feedback-custom"
              >
                price should be filled.
              </div>
            </div>
          </CCol>

          <CCol sm="3">
            <CInput
              label="Price"
              invalid-feedback="price should be filled"
              required
              v-model="$v.priceForm.price.$model"
              :is-valid="!$v.priceForm.price.$invalid"
            />
          </CCol>
        </CRow>
      </div>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton @click="submitForm" :disabled="$v.priceForm.$invalid" color="success">
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import Loading from "../../../../templates/Loading";
import GlobalTable from "../../../../templates/Table";

import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";

export default {
  name: "Price",
  components: { GlobalTable, Loading },
  data() {
    return {
      title: "Price",
      items: [],
      productPriceList: [],
      addButton: false,
      isEdit: false,
      priceForm: tableInterfaces.product_price,
      isLoading: false,
      image: null,
      activeTab: 0,
      checkedFlag: "Agent",
      fields: [
        { key: "price", label: "Price", sorter: true },
        { key: "price_for", label: "User Group", sorter: true },
        { key: "action", _classes: "text-center action" },
      ],
      acceptanceStatus: ["2", "7"],
    };
  },
  props: {
    products: {
      type: [Array, Object],
      default: () => [],
    },
    price: {
      type: [Array, Object],
      default: () => [],
    },
    productStatus: {
      type: String,
      default: null,
    },
  },
  validations: {
    priceForm: {
      price: { required },
      product_code: {},
      user_group: { required },
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  computed: {
    data: function () {
      return this.items.length > 0 ? this.items : this.price;
    },
  },
  methods: {
    init: function (id) {
      this.getDropdown();
    },
    refreshPrice: function (id) {
      this.isLoading = true;
      this.axios
        .get("console/product_price/listing/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            this.items = response.data.data;
            if (response.data.total_row.total_row == 2) {
              this.enableAddPrice = false;
            }
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
          this.cancelForm();
        });
    },
    addForm: function () {
      this.addButton = true;
      this.isEdit = false;
      this.resetForm();
    },
    cancelForm: function () {
      this.addButton = false;
      this.resetForm();
    },
    editForm: function (item) {
      this.addForm();
      this.isEdit = true;
      this.priceForm = item;
    },
    resetForm: function () {
      for (var i in tableInterfaces.product_price) {
        tableInterfaces.product_price[i] = null;
      }
      this.priceForm = tableInterfaces.product_price;
    },
    back: function () {
      this.$router.go(-1);
    },
    submitForm: function (event) {
      event.preventDefault();
      this.priceForm.product_code = this.products.product_code;
      if (this.isEdit === true) {
        if (confirm("Do you want to change this data ?")) {
          this.isLoading = true;
          this.axios
            .put("console/product_price/update", this.priceForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.refreshPrice(this.products.id);
            });
        }
      } else {
        if (confirm("Do you want to add this data ?")) {
          this.isLoading = true;
          this.axios
            .post("console/product_price/add", this.priceForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.refreshPrice(this.products.id);
            });
        }
      }
    },
    getDropdown: function () {
      this.axios.get("console/dropdown/user-group").then((response) => {
        this.productPriceList = response.data.data;
      });
    },
  },

  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);
  },
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
.ui.selection.dropdown.disabled {
  background-color: #d8dbe0;
  opacity: 0.8;
}
</style>
